
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if(elementToFocus){
    elementToFocus?.focus();
    
    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class VariantProductCard extends HTMLElement {
  constructor() {
    super();
  }

  // when the element is inserted into the DOM
  connectedCallback() {
    this.attachVariantClickListeners(); 
  }

  // Function to handle the click event on variant links
  handleVariantClick(event) {
    event.preventDefault();
    
    const variantLink = event.currentTarget; // Get the clicked link
    const handle = variantLink.getAttribute('data-handle');
    const productUrl = `${handle}?view=card`;
    fetch(productUrl)
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, "text/html");
        const newProductCard = html.querySelector('marmeto-product-card');
        
        // Find the grid item containing the product card
        const gridItem = variantLink.closest('.grid__item');

        if (gridItem && newProductCard) {
          // Replace the existing product card in the grid item with the new one
          const existingProductCard = gridItem.querySelector('marmeto-product-card');
          if (existingProductCard) {
            existingProductCard.outerHTML = newProductCard.outerHTML; // Replace the existing product card
          } else {
            gridItem.appendChild(newProductCard);
          }

          // Re-attach click listeners to the new variant links
          this.attachVariantClickListeners(); // Call this function after replacing the card
        }
      })
      .catch((error) => {
        console.error('Error fetching product data:', error);
      });
  }

  // Function to attach click listeners to variant links
  attachVariantClickListeners() {
    const variantLinks = this.querySelectorAll('.variant-link');
    variantLinks.forEach((variantLink) => {
      variantLink.addEventListener('click', (event) => this.handleVariantClick(event)); // Add new listener
    });
  }
}
customElements.define('variant-product-card', VariantProductCard);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();

      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    // if (window.location.href.indexOf("collections") > -1 && document.querySelector('#main-collection-filters .mobile-facets__disclosure')) {
    //   document.querySelector('#main-collection-filters .mobile-facets__disclosure').classList.add("!tw-z-[11]");
    // }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;

    if (window.location.href.indexOf("collections") > -1 && document.querySelector('#main-collection-filters .mobile-facets__disclosure')) {
      document.querySelector('#main-collection-filters .mobile-facets__disclosure').classList.remove("!tw-z-[11]");
    }

    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    this.addEventListener("click", (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal){
        modal.show(button);
        this.zoomMainProductMedia(modal);
      }
    });
  }

  zoomMainProductMedia(modal){
    if(!modal) return;
    const imageList = modal.querySelectorAll('.product-media-modal__media-item-image');
    imageList.forEach(imageEl=>{
      imageEl.addEventListener('mousemove', function(e){
        const zoomTarget = e.currentTarget;

        zoomTarget.addEventListener('mouseenter', () => {
          zoomTarget.style.backgroundSize = '200%';
        }, {once: true});

        zoomTarget.addEventListener('mousemove', (e) => {
          zoomTarget.style.backgroundSize = 'auto';
          const rect = zoomTarget.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          zoomTarget.style.backgroundPosition = `${x}% ${y}%`;
        });

        zoomTarget.addEventListener('mouseleave', () => {
          zoomTarget.style.backgroundSize = 'contain';
          zoomTarget.style.backgroundPosition = 'center';
        }, {once: true});
      })
    })
  }
}
customElements.define("modal-opener", ModalOpener);

// class DeferredMedia extends HTMLElement {
//   constructor() {
//     super();
//     const poster = this.querySelector('[id^="Deferred-Poster-"]');
//     if (!poster) return;
//     poster.addEventListener("click", this.loadContent.bind(this));
//     (async () => {
//       if (this.autoPlay) {
//         await this.untilVisible({ rootMargin: "300px", threshold: 0 });
//         poster.click();
//       } 
//     })();
//   }

//   get autoPlay() {
//     return this.hasAttribute("autoplay");
//   }

//   loadContent(focus = true) {
//     window.pauseAllMedia();
//     if (!this.getAttribute("loaded")) {
//       const content = document.createElement("div");
//       content.appendChild(
//         this.querySelector("template").content.firstElementChild.cloneNode(true)
//       );

//       this.setAttribute("loaded", true);
//       const deferredElement = this.appendChild(
//         content.querySelector("video, model-viewer, iframe")
//       );
//       if (focus) deferredElement.focus();
//       if (
//         deferredElement.nodeName == "VIDEO" &&
//         deferredElement.getAttribute("autoplay")
//       ) {
//         // force autoplay for safari
//         deferredElement.play();
//       }
//     }
//   }
//   untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
//     const onBecameVisible = () => {
//       this.classList.add("became-visible");
//       this.style.opacity = "1";
//     };
//     return new Promise((resolve) => {
//       if (window.IntersectionObserver) {
//         this.intersectionObserver = new IntersectionObserver((event) => {
//           if (event[0].isIntersecting) {
//             this.intersectionObserver.disconnect();
//             requestAnimationFrame(() => {
//               resolve();
//               onBecameVisible();
//             });
//           }
//         }, intersectionObserverOptions);
//         this.intersectionObserver.observe(this);
//       } else {
//         resolve();
//         onBecameVisible();
//       }
//     });
//   }
// }

// customElements.define("deferred-media", DeferredMedia);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    (async () => {
      if (this.autoPlay) {
        await this.untilVisible({ rootMargin: "300px", threshold: 0 });
        poster.click();
      }
    })();
  }

  get autoPlay() {
    return this.hasAttribute("autoplay");
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );


      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }

  untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };

    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
}

customElements.define("deferred-media", DeferredMedia);


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    const productGallery = document.getElementById(
      `ProductGallery-${this.dataset.section}`
    );

    if (!this.currentVariant.featured_media) {
      productGallery?.showAllMedia();
      return;
    }

    productGallery?.setActiveMedia(this.currentVariant.featured_media);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        // const cartDrawerBubble = document.getElementById("cart-icon-bubble");
        // cartDrawerBubble.innerHTML = html.getElementById("cart-icon-bubble")?.innerHTML;

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = 'Add to cart';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]:not(.variant-inventory)').textContent);
      const inventoryNode = this.querySelector('.variant-inventory');
      if (inventoryNode) {
        try {
          const inventoryData = JSON.parse(inventoryNode.textContent);
          this.variantData.forEach(variant => {
            const inv = inventoryData.find(i => i.id === variant.id);
            if (inv && inv.inventory_management === 'shopify' && inv.inventory_policy === 'deny' && inv.inventory_quantity < 3) {
              variant.available = false;
            }
          });
        } catch (e) {}
      }
    }
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.sizeDropDownContainer = this.querySelector('.product-size-dropdown__container')
    this.sizeDropDownButton = this.querySelector('.product-size-dropdown__button')
    this.selectedColor = this.querySelector('.selected--color');
    this.sizeDropDownButton.addEventListener('click', () => {
      this.showSizeDropdown()
    })

    this.updateOptions();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateOptionNames();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptionNames() {
    if (!this.querySelector('.option-selected-value')) return;
    [...this.querySelectorAll('legend')].forEach((legend, index) => legend.querySelector('.option-selected-value').innerHTML = this.currentVariant.options[index])
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// custom add-to-cart component 

// class FieldsetVariants extends HTMLElement {
//   constructor() {
//     super();
//     this.handleOptionClick = this.handleOptionClick.bind(this);
//   }

//   connectedCallback() {
//     this.variantOptions = this.querySelectorAll(".variant__option--size label");
//     this.variantOptions.forEach((option) => {
//       option.addEventListener("click", this.handleOptionClick);
//     });
//   }
  
//   handleOptionClick(event) {
//     const hiddenInput = event.currentTarget.previousElementSibling;
    
//     if (!hiddenInput) {
//       console.error("Hidden input with variant ID not found.");
//       return;
//     }

//     const variantId = hiddenInput.dataset.id;
//     if (!variantId) {
//       console.error("Variant ID is missing.");
//       return;
//     }

//     this.addToCart(variantId);
//   }

//   addToCart(variantId) {
//     let formData = {
//       items: [
//         {
//           id: parseInt(variantId),
//           quantity: 1,
//         }
//       ]
//     }
//     formData["sections"] = "cart-drawer"

//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData),
//     })
//       .then((response) => {
//         if (!response.ok) throw new Error("Failed to add product to cart.");
//         return response.json();
//       })
//       .then((data) => {
//         const cartMbBubble = document.getElementById('cart-icon-mb-bubble')
//         const cartdkBubble = document.getElementById('desktop-cart-bubble')
//         if (cartdkBubble) {
//           const quantity = parseInt(cartdkBubble.textContent)
//           cartdkBubble.innerHTML = quantity + 1;
//         }
//         if (cartMbBubble) {
//           const mobileCartQuantity = parseInt(cartMbBubble.textContent)
//           cartMbBubble.innerHTML = mobileCartQuantity + 1;
//         }
//         let responseCart = data.sections;
//         let cartDrawerSection = responseCart["cart-drawer"];
//         let tempDiv = document.createElement('div');
//         tempDiv.innerHTML = cartDrawerSection;
//         let cartDrawer = tempDiv.querySelector("#shopify-section-cart-drawer")
//         let oldCartDrawer = document.querySelector("#shopify-section-cart-drawer");
//         oldCartDrawer.innerHTML = cartDrawer.innerHTML;
//         return oldCartDrawer
//       })
//       .then((data) => {
//         let cartDrawerOpen = data.querySelector('cart-drawer')
//         cartDrawerOpen.classList.add('active')
//       })
//       .catch((error) => {
//         let outOfStockMsg = document.querySelector('.out-of-stock-notification');
//         outOfStockMsg.classList.remove('tw-bottom-[-10%]')
//         outOfStockMsg.classList.add('tw-bottom-[10%]');
//         setTimeout(() => {
//           outOfStockMsg.classList.remove('tw-bottom-[10%]');
//           outOfStockMsg.classList.add('tw-bottom-[-10%]')
//         }, 3000); 
//         console.error("Error:", error);
//       });
//   }
// }

// customElements.define("fieldset-variants", FieldsetVariants);
class FieldsetVariants extends HTMLElement {
  constructor() {
    super();
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }

  connectedCallback() {
    this.variantOptions = this.querySelectorAll(".variant__option--size label");
    this.variantOptions.forEach((option) => {
      option.addEventListener("click", this.handleOptionClick);
    });
  }

  handleOptionClick(event) {
    const label = event.currentTarget;
    const hiddenInput = label.previousElementSibling;

    if (!hiddenInput) {
      console.error("Hidden input with variant ID not found.");
      return;
    }

    const variantId = hiddenInput.dataset.id;
    if (!variantId) {
      console.error("Variant ID is missing.");
      return;
    }

    this.addToCart(variantId, label);
  }

  addToCart(variantId, label) {
    const originalText = label.textContent; 
    label.textContent = ""; 

    // Create spinner element
    const spinner = document.createElement("span");
    spinner.classList.add("spinner");
    label.appendChild(spinner);

    let formData = {
      items: [
        {
          id: parseInt(variantId),
          quantity: 1,
        },
      ],
    };
    formData["sections"] = "cart-drawer";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add product to cart.");
        return response.json();
      })
      .then((data) => {
        const cartMbBubble = document.getElementById("cart-icon-mb-bubble");
        const cartdkBubble = document.getElementById("desktop-cart-bubble");

        if (cartdkBubble) {
          const quantity = parseInt(cartdkBubble.textContent) || 0;
          cartdkBubble.innerHTML = quantity + 1;
        }
        if (cartMbBubble) {
          const mobileCartQuantity = parseInt(cartMbBubble.textContent) || 0;
          cartMbBubble.innerHTML = mobileCartQuantity + 1;
        }

        let responseCart = data.sections;
        let cartDrawerSection = responseCart["cart-drawer"];
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = cartDrawerSection;
        let cartDrawer = tempDiv.querySelector("#shopify-section-cart-drawer");
        let oldCartDrawer = document.querySelector("#shopify-section-cart-drawer");
        oldCartDrawer.innerHTML = cartDrawer.innerHTML;
        return oldCartDrawer;
      })
      .then((data) => {
        let cartDrawerOpen = data.querySelector("cart-drawer");
        cartDrawerOpen.classList.add("active");
      })
      .catch((error) => {
        let outOfStockMsg = document.querySelector(".out-of-stock-notification");
        outOfStockMsg.classList.remove("tw-bottom-[-10%]");
        outOfStockMsg.classList.add("tw-bottom-[10%]");
        setTimeout(() => {
          outOfStockMsg.classList.remove("tw-bottom-[10%]");
          outOfStockMsg.classList.add("tw-bottom-[-10%]");
        }, 3000);
        console.error("Error:", error);
      })
      .finally(() => {
        label.textContent = originalText; // Restore original label text
        if (spinner.parentNode) {
          spinner.parentNode.removeChild(spinner); // Remove spinner
        }
      });
  }
}

customElements.define("fieldset-variants", FieldsetVariants);



// Marmeto Product Card

class MarmetoProductCard extends HTMLElement {
  constructor() {
      super();
      this.sectionId = this.dataset.sectionId
      this.addEventListener('change', event => {
          if (!event.target.hasAttribute('product-complementary') && !event.target.closest('.marmeto-wishlist-group')) this.variantChange();
      })
      this.addEventListener('click', event => {
          if (event.target.classList.contains('size-option__button')) {
              this.toggleQuickView(event.target);
          }
      });
  }

  variantChange() {
      this.selectedVariantId = this.querySelector('[name="id"]').value;
      this.templateParam = this.closest('multi-product-form') ? 'card-complementary' : 'card';
      let variantUrl = `/products/${this.dataset.productHandle}?view=${this.templateParam}&variant=${this.selectedVariantId}&section=${this.sectionId}`;

      //Change the DOM Elements
      fetch(variantUrl)
          .then((response) => response.text())
          .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              const responseCard = html.querySelector("marmeto-product-card");

              /**
                Code added by Variant Swatch King to control the re-rendering of necessary DOM elements.
              */
              if (responseCard) {
                  // Find all elements with class 'tw-isolate' and 'product-card__info' in the current card
                  const currentElements = this.querySelectorAll(".tw-isolate, .product-card__info");
                  currentElements.forEach((currentElement) => {
                      // Find the corresponding element in the responseCard using a matching selector
                      const selector = `.${Array.from(currentElement.classList).join('.')}`;
                      const responseElement = responseCard.querySelector(selector);
                      // If a matching element is found in the response card, update its innerHTML
                      if (responseElement) {
                          currentElement.innerHTML = responseElement.innerHTML;
                      }
                  });
              }
          });
  }
  toggleQuickView(button) {
    const variantRadios = this.querySelector('mm-variant-radios.openable-element');
    if (variantRadios) {
        if (variantRadios.classList.contains('show-options')) {
            variantRadios.classList.remove('show-options');
        } else {
            variantRadios.classList.add('show-options');
            const handleClickOutside = (event) => {
                if (!variantRadios.contains(event.target) && !button.contains(event.target)) {
                    variantRadios.classList.remove('show-options');
                    document.removeEventListener('click', handleClickOutside);
                }
            };
            document.addEventListener('click', handleClickOutside);
        }
    }
  }

}
customElements.define("marmeto-product-card", MarmetoProductCard);

class MMvariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    this.updateComplementaryProductCheckbox();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
    }
  }

  updateComplementaryProductCheckbox() {
    this.complementaryProductCheckbox = this.closest('marmeto-product-card')?.querySelector('[type="checkbox"][name="id"]');

    if (!this.complementaryProductCheckbox) return;

    this.complementaryProductCheckbox?.classList.remove('hidden')

    if (this.complementaryProductCheckbox && !this.currentVariant?.available) {
      this.complementaryProductCheckbox.classList.add('hidden')
    }

    this.complementaryProductCheckbox.value = this.currentVariant.id;
    this.complementaryProductCheckbox.dataset.price = this.currentVariant.price;
  }
  
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#mm-product-form--${this.dataset.pid}`);
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `mm-product-form--${this.dataset.pid}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = "Add to cart";
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `mm-product-form--${this.dataset.pid}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.pid}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }
  
  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]:not(.variant-inventory)').textContent);
      const inventoryNode = this.querySelector('.variant-inventory');
      if (inventoryNode) {
        try {
          const inventoryData = JSON.parse(inventoryNode.textContent);
          this.variantData.forEach(variant => {
            const inv = inventoryData.find(i => i.id === variant.id);
            if (inv && inv.inventory_management === 'shopify' && inv.inventory_policy === 'deny' && inv.inventory_quantity < 3) {
              variant.available = false;
            }
          });
        } catch (e) {}
      }
    }
    return this.variantData;
  }
}

customElements.define("mm-variant-selects", MMvariantSelects);

class MMvariantRadios extends MMvariantSelects {
  constructor() {
    super();

    this.sizeDropDownContainer = this.querySelector('.product-size-dropdown__container')
    this.sizeDropDownButton = this.querySelector('.product-size-dropdown__button')
    this.selectedColor = this.querySelector('.selected--color');
    this.sizeDropDownButton?.addEventListener('click', () => {
      this.showSizeDropdown()
    })

    this.updateOptions();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    this.updateComplementaryProductCheckbox();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      // this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.updateOptionNames();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return this.options[0] === variant.option2;
    });
  }
  
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#mm-product-form--${this.dataset.pid}`);
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateOptionNames() {
    if (!this.querySelector('.option-selected-value')) return;
    [...this.querySelectorAll('legend')].forEach((legend, index) => legend.querySelector('.option-selected-value') ? legend.querySelector('.option-selected-value').innerHTML = this.currentVariant.options[index] : null)
  }


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {

    const fieldsets = Array.from(this.querySelectorAll('fieldset-variants'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });
  }
  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]:not(.variant-inventory)').textContent);
      const inventoryNode = this.querySelector('.variant-inventory');
      if (inventoryNode) {
        try {
          const inventoryData = JSON.parse(inventoryNode.textContent);
          this.variantData.forEach(variant => {
            const inv = inventoryData.find(i => i.id === variant.id);
            if (inv && inv.inventory_management === 'shopify' && inv.inventory_policy === 'deny' && inv.inventory_quantity < 3) {
              variant.available = false;
            }
          });
        } catch (e) {}
      }
    }
    return this.variantData;
  }
}

customElements.define("mm-variant-radios", MMvariantRadios);

// custom-element.js
class MarmetoWishlist extends HTMLElement {
  static pendingOperations = [];

  constructor() {
    super();
    this.input = this.querySelector('input');
  }

  connectedCallback() {
    this.input.addEventListener('change', this.debounce(this.handleCheckboxChange, 300));
  }

  handleCheckboxChange() {
    const value = JSON.parse(this.value);
    const [customerId, productId] = value;
    const action = this.checked ? 'add' : 'remove';
    const removeDeselectedWishlistCard = this.dataset.removeDeselectedWishlistCard == 'true';
    MarmetoWishlist.customerId = customerId; // Converting the customer ID to class variable

    if (!this.checked && removeDeselectedWishlistCard) MarmetoWishlist.removeProductCard(this);

    // Create an operation object
    const operation = { productId, action };

    MarmetoWishlist.pendingOperations.push(operation);
    MarmetoWishlist.handleBatchOperations();

    document.querySelectorAll(`[value="${this.value}"]:not([id="${this.id}"])`).forEach(wishlistInput => {
      wishlistInput.checked = !wishlistInput.checked;
    })
  }

  static async handleBatchOperations(operations = MarmetoWishlist.pendingOperations) {
    if (operations.length === 0) {
      return; // No operations to perform
    }

    // Storing it to localStorage in case the user switches page
    localStorage.setItem('pendingWishlistOperations', JSON.stringify(operations))

    // Check if there is an ongoing network request
    if (MarmetoWishlist.abortController) {
      MarmetoWishlist.abortController.abort();
    }

    MarmetoWishlist.abortController = new AbortController();

    // Define the URL
    const deploymentId = 'AKfycbz3Al5G_4JuAWhMtQZCLirsAozV2_5I16_hs_pkHL0sp262LRmhCC_UZOCUoFOHcCk'
    const url = `https://script.google.com/macros/s/${deploymentId}/exec`;
    const payloadData = {
      customerId: MarmetoWishlist.customerId,
      operations
    };

    // Create the fetch options
    const options = {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payloadData),
      signal: MarmetoWishlist.abortController.signal
    };

    // Perform the operation
    try {
      const response = await fetch(url, options);
      // Clear the pendingOperations
      localStorage.removeItem('pendingWishlistOperations')
      MarmetoWishlist.pendingOperations = [];
      MarmetoWishlist.updateCentralWishlistIcon();
    } catch (error) {
      console.error(`Error in request:`, error);
    }
  }

  static updateCentralWishlistIcon() {
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
    request.open('GET', '/?sections=wishlist-count', true);
    request.send();

    function handleResponse() {
      const html = new DOMParser().parseFromString(JSON.parse(this.responseText)['wishlist-count'], 'text/html');
      const selector = '.wishlist__count';

      const targetElement = document.querySelectorAll(selector);
      const sourceElement = html.querySelector('#wishlist-count');

      targetElement.forEach((each) => {
        each.textContent = sourceElement.textContent
      })
    }
  }

  static removeProductCard(input) {
    input.closest('marmeto-product-card').remove();
  }

  debounce(func, delay) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }
}

customElements.define('marmeto-wishlist', MarmetoWishlist);
// , { extends: 'input' }

if (localStorage.getItem('pendingWishlistOperations')) {
  MarmetoWishlist.handleBatchOperations(JSON.parse(localStorage.getItem('pendingWishlistOperations')))
}

class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('#product-grid')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.addObserver();
  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {

      if (entry.isIntersecting) {
        if (entry.target == this.loadActivatorElem)
          observer.disconnect();

        var nextPageUrl = this.getNextPageUrl()

        if (nextPageUrl)
          this.loadProducts(nextPageUrl)
      }

    }, {
      root: null,
      threshold: 0.1
    })

    observer.observe(this)
  }

  getNextPageUrl() {
    var nextPage = parseInt(this.dataset.currentpage) + 1;

    if (nextPage > this.dataset.totalpages) {
      return false
    }

    return this.constructURLWithSearchParams(nextPage)
  }

  constructURLWithSearchParams(page) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;
    var pageParam = this.dataset.pageParam || 'page'

    params.set(pageParam, nextPage)
    // params.set('filter.v.availability', 1) // To set the available products by default

    var searchParamsAsString = params.toString()

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading')
    this.querySelector('div').classList.remove('hidden')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          if (insertPosition == 'append') {
            //Appending new sets of product cards
            _this4.collectionInnerElement.insertAdjacentHTML('beforeend', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('infinite-page-loader').dataset.currentpage
            _this4.dataset.totalpages = tempElement.querySelector('infinite-page-loader').dataset.totalpages
          }
          else if (insertPosition == 'prepend') {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }

          _this4.init();
          _this4.saveScrollPoint();

          _this4.classList.remove('loading')
          _this4.querySelector('div').classList.add('hidden')
        });
      });
    } catch (exception) { }
  }

  saveScrollPoint() {
    let productCards = document.querySelectorAll("marmeto-product-card");

    productCards.forEach((productCard) => {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, productCard)
      },
        { threshold: 0.7 });
      observer.observe(productCard); // Observing each product card that is visible

      productCard.addEventListener('click', () => {
        sessionStorage.setItem("lastElementId", productCard.id);
      });
    })

    const observerCallback = (entries, observer, header) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting && entry.target.dataset.page) {
          this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
        }
      });
    };
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;

    history.scrollRestoration = "manual";
    // Reverting back to the previous element that was being viewed. 
    window.onload = function () {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement)
        lastElement.scrollIntoView();

      sessionStorage.removeItem('lastElementId');
    };
  }
}

customElements.define('infinite-page-loader', InfinitePageLoader);

class LoadPreviousPage extends InfinitePageLoader {
  constructor() {
    super();

    this.addEventListener('click', this.loadProducts.bind(this));
  }

  connectedCallback() {
    this.init()
  }

  init() {
    var infinitePageLoader = document.querySelector('infinite-page-loader')
    var maxPagesLoadable = this.dataset.totalpages - 1;

    if (infinitePageLoader.dataset.currentpage - this.dataset.currentpage == maxPagesLoadable //when all the pages are loaded
      || this.dataset.currentpage == 1) { // When user is at page 1
      this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }
  }

  loadProducts() {
    if (this.classList.contains('loading')) return;

    var prevPageUrl = this.getPrevPageUrl()

    if (prevPageUrl) {
      this.classList.add('loading')
      this.getAndInsertHtml(prevPageUrl, 'prepend')
    }
  }

  getPrevPageUrl() {
    var prevPage = parseInt(this.dataset.currentpage) - 1;

    if (prevPage < 1) {
      return false
    }

    return this.constructURLWithSearchParams(prevPage)
  }
}

customElements.define('load-previous-page', LoadPreviousPage);

// custom scroll button for product card variant swatches 
class ScrollButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick);
  }
  
  handleClick() {
    const direction = this.getAttribute("direction");
    const targetSelector = this.getAttribute("data-target");
    const scrollAmount = parseInt(this.getAttribute("scroll-amount")) || 50;
    
    if (!direction || !targetSelector) {
      console.error("Direction or target is not defined!");
      return;
    }
    
    const targetElement = this.closest(targetSelector) || this.parentElement.querySelector(targetSelector);
    
    if (targetElement) {
      targetElement.scrollBy({
        left: direction === "prev" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    } else {
      console.error(`No element found for selector: ${targetSelector}`);
    }
  }
}

// Define the custom element
customElements.define("scroll-button", ScrollButton);


// BRA SIZE CALCULATOR PAGE
let yourPerfectSize = sessionStorage.getItem('cupfitting');
let collectionBannerImage = document.querySelector('.collection-main-banner-image');
let selectedPreferSize =  document.querySelector('.your-perfect-size-container');
if (yourPerfectSize){
  selectedPreferSize?.classList.remove('hidden');
  collectionBannerImage?.classList.add('hidden')
  sessionStorage.removeItem('cupfitting');
} else {
  selectedPreferSize?.classList.add('hidden');
  collectionBannerImage?.classList.remove('hidden')
}

let storedMatchingSize = sessionStorage.getItem('matchingSize');
if (storedMatchingSize) {
  const element = document.querySelector('.user-selected-bra-size');
  if (element) {
    element.textContent = storedMatchingSize;
  }
}
// Function to toggle popup visibility
function togglePopup() {
  let popup = document.getElementById('customPopup');
  let overlay = document.querySelector('.popup-overlay');
  popup.classList.toggle('show');
  overlay.classList.toggle('show');
  // Toggle body overflow
  if (popup.classList.contains('show')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}
// Function to close the popup
function closePopup() {
  let popup = document.getElementById('customPopup');
  let overlay = document.querySelector('.popup-overlay');
  popup.classList.remove('show');
  overlay.classList.remove('show');
  document.body.style.overflow = '';
}

//fetching the data from the google sheet 
let sheetKey = "1JXC-poBJX5w-dyE5I0v2XfUdZ3CokYVum-lOe7EdUbc";
let apiKey = "AIzaSyBWV6yc0AP1G7pONrBJh2XSZJ0Vr9o62lg";
let cmRange = "A5:C44";
let inchesRange = "A50:C89";
let currentRange = cmRange; // Default to centimeters range

let sheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/" + sheetKey + "/values/" + currentRange + "?key=" + apiKey;

let dropdownContainers = document.querySelectorAll('.dropdown');
let underBustDropdown = dropdownContainers && dropdownContainers[0] ? dropdownContainers[0].querySelector('.dropdown__select') : null;
let overBustDropdown = dropdownContainers && dropdownContainers[1] ? dropdownContainers[1].querySelector('.dropdown__select') : null;

// Function to fetch data from Google Sheets API
function fetchSheetData(range) {
  let url = "https://sheets.googleapis.com/v4/spreadsheets/" + sheetKey + "/values/" + range + "?key=" + apiKey;

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const values = data.values || [];

      const underBustOptions = [...new Set(values.map(row => row[0]))];
      const overBustOptions = [...new Set(values.map(row => row[1]))];

      // Populate under bust dropdown options
      if(underBustDropdown){
      underBustDropdown.innerHTML = '';
      underBustOptions?.forEach(option => {
        const li = document.createElement('li');
        li.textContent = option;
        li.classList.add('dropdown__select-option');
        li.setAttribute('role', 'option');
        underBustDropdown.appendChild(li);
      });
    }

      // Populate over bust dropdown options
      if(overBustDropdown){
      overBustDropdown.innerHTML = '';
      overBustOptions?.forEach(option => {
        const li = document.createElement('li');
        li.textContent = option;
        li.classList.add('dropdown__select-option');
        li.setAttribute('role', 'option');
        overBustDropdown.appendChild(li);
      });
    }

      // Event listener for selecting under bust option
      underBustDropdown?.addEventListener('click', function (event) {
        const selectedUnderBust = event.target.textContent;
        const dropdownLabel = document.querySelectorAll('.dropdown .dropdown__filter-selected')[0];
        dropdownLabel.setAttribute('data-underbust', selectedUnderBust);
        dropdownLabel.textContent = selectedUnderBust;
        updateOverBustOptions(selectedUnderBust);
        document.querySelector('.size-calculator-error-message').classList.add('hidden')
      });

      // Event listener for selecting over bust option
      overBustDropdown?.addEventListener('click', function (event) {
        const selectedOverBust = event.target.textContent;
        const dropdownLabel = document.querySelectorAll('.dropdown .dropdown__filter-selected')[1];
        const underBustSelected = document.querySelectorAll('.dropdown .dropdown__filter-selected')[0].getAttribute('data-underbust');

        if (!underBustSelected) {
          // Display error message because Under Bust value is not selected
          const errorMessage = document.querySelector('.size-calculator-error-message');
          errorMessage.textContent = "Please select Under Bust value first.";
          errorMessage.classList.remove('hidden');
          return;
        }

        // If Under Bust is selected, update Over Bust dropdown as usual
        dropdownLabel.setAttribute('data-overbust', selectedOverBust);
        dropdownLabel.textContent = selectedOverBust;
        document.querySelector('.size-calculator-error-message').classList.add('hidden');
      });

    })
    .catch(error => console.error('Error fetching data from Google Sheets API:', error));
}

// Function to update over bust options based on selected under bust
function updateOverBustOptions(selectedUnderBust) {
  let range = currentRange;
  fetch(sheetUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const values = data.values || [];
      const overBustOptionsFiltered = values
        .filter(row => row[0] === selectedUnderBust)
        .map(row => row[1]);

      // Populate over bust dropdown options
      overBustDropdown.innerHTML = '';
      overBustOptionsFiltered.forEach(option => {
        const li = document.createElement('li');
        li.textContent = option;
        li.classList.add('dropdown__select-option');
        li.setAttribute('role', 'option');
        overBustDropdown.appendChild(li);
      });
    })
    .catch(error => console.error('Error fetching data from Google Sheets API:', error));
}

// Initial fetch and setup with default range (centimeters)
fetchSheetData(currentRange);

function updateHeadings() {
  // Update overBustHeading
  let overBustHeading = document.querySelector('#over-heading');
  if (overBustHeading) {
    let overHeading = overBustHeading.getAttribute('data-overheading');
    overBustHeading.textContent = overHeading;
  }
  // Update underBustHeading
  let underBustHeading = document.querySelector('#under-heading');
  if (underBustHeading) {
    let underHeading = underBustHeading.getAttribute('data-underheading');
    underBustHeading.textContent = underHeading;
  }
}


// Event listener for switching to centimeters
document.getElementById('cm-button')?.addEventListener('click', function () {
  updateHeadings();
  currentRange = cmRange;
  sheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/" + sheetKey + "/values/" + currentRange + "?key=" + apiKey;
  fetchSheetData(currentRange);
  // Add active class to cm-button and remove from inches-button
  document.getElementById('cm-button')?.classList.add('active-button');
  document.getElementById('inches-button')?.classList.remove('active-button');
});

// Event listener for switching to inches
document.getElementById('inches-button')?.addEventListener('click', function () {
  updateHeadings();
  currentRange = inchesRange;
  sheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/" + sheetKey + "/values/" + currentRange + "?key=" + apiKey;
  fetchSheetData(currentRange);

  // Add active class to inches-button and remove from cm-button
  document.getElementById('inches-button').classList.add('active-button');
  document.getElementById('cm-button').classList.remove('active-button');
});

// Event listener for finding matching size
document.querySelector('.current-size-button')?.addEventListener('click', function () {
  const dropDownSelectedUnderBust = document?.querySelectorAll('.dropdown .dropdown__filter-selected')[0];
  const dropDownSelectedOverBust = document?.querySelectorAll('.dropdown .dropdown__filter-selected')[1];
  let userUnderBust = dropDownSelectedUnderBust?.getAttribute('data-underbust');
  let userOverBust = dropDownSelectedOverBust.getAttribute('data-overbust');
  let errorMessageContent = document.querySelector('.size-calculator-error-message');
  sessionStorage.setItem('underbustvalue', userUnderBust);
  sessionStorage.setItem('overbustvalue', userOverBust);
  // Fetch the current data range based on the selected unit
  let range = (currentRange === cmRange) ? "A5:C44" : "A50:C89";
  let sheetUrl = "https://sheets.googleapis.com/v4/spreadsheets/" + sheetKey + "/values/" + range + "?key=" + apiKey;
  
  // Fetch data from Google Sheets API
  fetch(sheetUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Iterate through the data to find the matching size
      let matchingSize = findMatchingSize(data.values, userUnderBust, userOverBust);
      // Output the matching size
      if (matchingSize) {
        // Store matchingSize in session storage
        sessionStorage.setItem('matchingSize', matchingSize);
        let currentSize = document.querySelector('.current-size-button');
        let hyperlink = currentSize.getAttribute('data-hyperlink');
        window.location.href = hyperlink;
      } else {
        errorMessageContent.textContent = 'Please select an option from both dropdowns.';
        errorMessageContent.classList.remove('hidden')
      }
    })
    .catch(error => console.error('Error fetching data from Google Sheets API:', error));
});

// Function to find matching size in the fetched data
function findMatchingSize(data, underBust, overBust) {
  for (let i = 0; i < data.length; i++) {
    let row = data[i];
    if (row[0] === underBust && row[1] === overBust) {
      return row[2];
    }
  }
  return null;
}

/* ==========================================================
   LAZY LOAD SECTIONS (Shopify Section Rendering API)
   ========================================================== */
class LazySection extends HTMLElement {
  static queue = new Set();
  static batchTimeout = null;

  constructor() {
    super();
    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
    this.isLoaded = false;
    this.isFetching = false;
  }

  connectedCallback() {
    if (this.isLoaded) return;

    if (!this.section) {
      this.section = this.dataset.sectionId ||
                     (this.closest('.shopify-section') || this.closest('[id^="shopify-section-"]'))?.id?.replace(/^shopify-section-/, '');
    }

    if (!this.section) return;

    this.shimmerContainer = this.querySelector('.skeleton-container');

    const targetElement = document.querySelector(this.targetSelector);
    if (this.trigger === 'mouseover' && targetElement) {
      if (screen.width < 990) return;
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click' && targetElement) {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          rootMargin: '800px 0px 800px 0px',
        });
        this.observer.observe(this);
      } else {
        this.fetchSection();
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.removeTrigger();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.fetchSection();
  }

  handleMouseover() {
    this.removeTrigger();
    this.fetchSection();
  }

  handleClick() {
    this.removeTrigger();
    this.fetchSection();
  }

  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);
    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }

  fetchSection() {
    if (this.isLoaded || this.isFetching || !this.section) return;
    this.isFetching = true;

    if (this.shimmerContainer) {
      this.shimmerContainer.classList.remove('hidden');
    }

    LazySection.queue.add(this.section);

    if (LazySection.batchTimeout) {
      clearTimeout(LazySection.batchTimeout);
    }

    // Debounce batching by 30ms to group sections that enter viewport together
    LazySection.batchTimeout = setTimeout(() => {
      const allQueued = Array.from(LazySection.queue);
      LazySection.queue.clear();
      if (allQueued.length === 0) return;

      // Batch in groups of up to 5 sections per HTTP request
      while (allQueued.length > 0) {
        const batch = allQueued.splice(0, 5);
        LazySection.executeBatchFetch(batch);
      }
    }, 30);
  }

  static executeBatchFetch(batch) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('sections', batch.join(','));
    const url = window.location.pathname + '?' + searchParams.toString();

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status} ${response.statusText} for URL ${url}`);
        }
        return response.json();
      })
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const cleanKey = key.replace(/^shopify-section-/, '');
          
          // Robust multi-strategy live section DOM element discovery
          let liveSection = document.getElementById('shopify-section-' + cleanKey) ||
                             document.getElementById('shopify-section-' + key) ||
                             document.getElementById(cleanKey) ||
                             document.getElementById(key);

          if (!liveSection) {
            liveSection = document.querySelector(`[id$="${cleanKey}"]`) ||
                          document.querySelector(`lazy-section[data-section-id="${cleanKey}"]`)?.closest('.shopify-section') ||
                          document.querySelector(`lazy-section[data-section-id="${key}"]`)?.closest('.shopify-section');
          }

          if (!liveSection) continue;

          const doc = new DOMParser().parseFromString(value, 'text/html');
          const sectionContent = doc.getElementById('shopify-section-' + cleanKey) ||
                                 doc.getElementById('shopify-section-' + key) ||
                                 doc.getElementById(cleanKey) ||
                                 doc.getElementById(key) ||
                                 doc.querySelector('.shopify-section');

          const newHTML = sectionContent ? sectionContent.innerHTML : (doc.body ? doc.body.innerHTML : value);

          if (newHTML && newHTML.trim().length) {
            liveSection.innerHTML = newHTML;

            // Re-execute script tags to ensure interactive components initialize
            liveSection.querySelectorAll('script').forEach((oldScript) => {
              try {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes).forEach((attr) => {
                  if (attr.name === 'type' && attr.value === 'lazy-script') return;
                  newScript.setAttribute(attr.name, attr.value);
                });
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript);
              } catch (scriptErr) {
                // Ignore safe duplicate script re-registration
              }
            });

            // Re-mount / refresh any carousel components inside liveSection
            liveSection.querySelectorAll('carousel-component').forEach((carouselEl) => {
              try {
                if (carouselEl.carousel && typeof carouselEl.carousel.refresh === 'function') {
                  carouselEl.carousel.refresh();
                } else if (typeof carouselEl.initCarousel === 'function') {
                  carouselEl.initCarousel();
                }
              } catch (carouselErr) {
                // Ignore carousel refresh edge cases
              }
            });

            // Mark lazy section instance as loaded
            const lazyEl = liveSection.querySelector('lazy-section');
            if (lazyEl) {
              lazyEl.isLoaded = true;
              lazyEl.isFetching = false;
            }

            // Notify theme custom elements & components
            document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: key } }));
            window.dispatchEvent(new CustomEvent('lazy-sections:loaded', { detail: { sectionId: key } }));
          }
        }
      })
      .catch((err) => {
        console.warn('LazySection fetch issue:', err);
      });
  }
}

if (!customElements.get('lazy-section')) {
  customElements.define('lazy-section', LazySection);
}

// Trigger all lazy sections on initial user interaction as a fallback
const triggerLazySectionsOnce = () => {
  document.querySelectorAll('lazy-section').forEach((el) => {
    if (typeof el.fetchSection === 'function') {
      el.fetchSection();
    }
  });
  ['scroll', 'mousemove', 'touchstart', 'click'].forEach((event) =>
    window.removeEventListener(event, triggerLazySectionsOnce)
  );
};

['scroll', 'mousemove', 'touchstart', 'click'].forEach((event) =>
  window.addEventListener(event, triggerLazySectionsOnce, { once: true, passive: true })
);
// Re-initialize third-party wishlist (HulkApps) on dynamically loaded sections & page navigation
let hulkStatusTimer = null;

const reinitHulkWishlist = (sectionId) => {
  const hulk = window.hulkappsWishlistCollection;
  if (!hulk) return;

  // Sync latest guest UUID from cookie if available
  const uuid = window.HulkappWishlist?._getCookie?.('hulk_wishlist_UserUUID');
  if (uuid && typeof hulk._setCookie === 'function') {
    hulk._setCookie('hulk_wishlist_UserUUID', uuid, 15);
  }

  if (!window.collectionWishlistBtn && typeof hulk.init === 'function') {
    hulk.init();
    return;
  }

  const cleanKey = sectionId?.replace(/^shopify-section-/, '');
  const container = cleanKey
    ? document.getElementById('shopify-section-' + cleanKey) || document.getElementById(cleanKey) || document
    : document;

  container.querySelectorAll('.grid__item').forEach((item) => {
    if (item.querySelector('[data-gridwlhulklist]')) return;

    const proId = item.querySelector('mm-variant-radios')?.dataset?.pid || null;
    const handle = item.querySelector('marmeto-product-card')?.dataset?.productHandle
      || item.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0];

    if (handle && typeof hulk._addWishlistBtn === 'function') {
      hulk._addWishlistBtn(proId, item, handle);
    }
  });

  // Debounce API status check to batch multiple lazy sections into a single request
  clearTimeout(hulkStatusTimer);
  hulkStatusTimer = setTimeout(() => {
    window.wishlistBtns = Array.from(document.querySelectorAll('[data-gridwlhulklist]'));
    if (window.wishlistBtns.length > 0 && typeof hulk._collectionProductStatus === 'function') {
      hulk._collectionProductStatus();
    }
  }, 50);
};

window.addEventListener('lazy-sections:loaded', (e) => reinitHulkWishlist(e.detail?.sectionId));
document.addEventListener('shopify:section:load', (e) => reinitHulkWishlist(e.detail?.sectionId));
window.addEventListener('pageshow', () => reinitHulkWishlist());
